<template>
  <div class="container legal-page">
    <div class="legal-page__card shadow-sm">
      <div v-if="documentData">
        <div class="legal-page__eyebrow">Slackline TJS</div>
        <h1 class="legal-page__title">{{ documentData.title }}</h1>

        <LegalSectionRenderer
          v-for="([sectionNumber, section]) in orderedSections"
          :key="sectionNumber"
          :section="section"
          :section-number="sectionNumber"
          :heading-level="2"
        />
      </div>

      <div v-else class="legal-page__empty">
        {{ tOr('common.legal_document_missing', 'El documento legal solicitado no está disponible.') }}
      </div>
    </div>
  </div>
</template>

<script>
import LegalSectionRenderer from '@/components/legal/LegalSectionRenderer.vue';

const DOCUMENT_KEYS = {
  'privacy-policy': 'privacy_policy',
  'cookies-policy': 'cookies_policy',
  'terms-conditions': 'terms_conditions',
};

export default {
  name: 'LegalDocumentView',
  components: { LegalSectionRenderer },
  computed: {
    documentKey() {
      return DOCUMENT_KEYS[this.$route.params.document] || null;
    },
    activeLocale() {
      const locale = this.$i18n?.locale;
      if (typeof locale === 'string' && locale) {
        return locale;
      }

      const globalLocale = this.$i18n?.global?.locale;
      if (globalLocale && typeof globalLocale === 'object' && 'value' in globalLocale) {
        return globalLocale.value || 'en';
      }
      if (typeof globalLocale === 'string' && globalLocale) {
        return globalLocale;
      }

      return 'en';
    },
    allMessages() {
      return this.$i18n?.messages || this.$i18n?.global?.messages || {};
    },
    localeMessages() {
      return this.allMessages?.[this.activeLocale] || {};
    },
    fallbackMessages() {
      return this.allMessages?.en || {};
    },
    documentData() {
      if (!this.documentKey) {
        return null;
      }

      const localizedDocument = this.localeMessages?.[this.documentKey];
      if (localizedDocument && typeof localizedDocument === 'object' && Object.keys(localizedDocument).length > 0) {
        return localizedDocument;
      }

      const fallbackDocument = this.fallbackMessages?.[this.documentKey];
      if (fallbackDocument && typeof fallbackDocument === 'object' && Object.keys(fallbackDocument).length > 0) {
        return fallbackDocument;
      }

      return null;
    },
    orderedSections() {
      const sections = this.documentData?.sections || {};
      return Object.entries(sections).sort((left, right) => Number(left[0]) - Number(right[0]));
    },
  },
  methods: {
    tOr(key, fallback) {
      return typeof this.$te === 'function' && this.$te(key) ? this.$t(key) : fallback;
    },
  },
};
</script>

<style scoped>
.legal-page {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.legal-page__card {
  background: #ffffff;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 20px;
  padding: 1.5rem;
  font-size: 0.95rem;
}

.legal-page__eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #0f766e;
  font-size: 0.82rem;
  font-weight: 700;
}

.legal-page__title {
  margin-top: 0.4rem;
  margin-bottom: 1.4rem;
  color: #0f172a;
  font-size: 1.7rem;
  line-height: 1.2;
}

.legal-page__empty {
  color: #475569;
}

@media (max-width: 767.98px) {
  .legal-page__card {
    padding: 1.15rem;
    font-size: 0.92rem;
  }

  .legal-page__title {
    font-size: 1.42rem;
  }
}
</style>